import { SlotGameType1_21 } from '../SlotGameType1_21';

export class LuckyFire521 extends SlotGameType1_21
{
}
